import { apiRequest } from "../client/apiClient";
import { retryRequest } from "../helpers/retryRequest";

export async function uploadMedia(imageFile) {
  const formData = new FormData();
  formData.append("file", imageFile);
  return retryRequest(() =>
    apiRequest("/media/uploadfile", {
      method: "POST",
      body: formData,
    }),
  );
}
